exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".images-list{width:100%;max-width:890px;margin:110px auto;display:grid;grid-template-columns:1fr 1fr;gap:20px}.images-list img{width:100%;border-radius:20px}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/ui/Images/Images.scss
// module id = 431
// module chunks = 0